export var splitButtonDividerStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        variables = _ref.variables;
    return {
      height: 'auto',
      alignItems: 'center',
      display: 'inline-block',
      '::before': Object.assign({
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: "1px",
        height: '100%',
        zIndex: 1,
        background: variables.dividerColor
      }, props.primary && {
        background: variables.dividerPrimaryColor
      })
    };
  }
};